<template>
    <div v-if="itinerary" class="width100 scroll">
        <div class="width100 flex">
            <div class="col1">&nbsp;</div>
            <div class="col2">
                Bestemming
            </div>
            <div class="col3">Aankomst</div>
            <div class="col3">Vertrek</div>
            <div class="col1">&nbsp;</div>
        </div>
        <CruiseItineraryDetail
            v-for="(port, day) in itinerary.days"
            :key="day"
            :index="day"
            :port="port"
            :rederij_id="rederij_id"
            :cruise_id="cruise_id"

        />
    </div>
</template>

<script>
import CruiseItineraryDetail from './CruiseItineraryDetail.vue'

export default {
    name: 'CruiseItinerary',
    props: {
        itinerary: Object,
        rederij_id: Number,
        cruise_id: Number,
    },
    components: {
        CruiseItineraryDetail,
    },
}
</script>

<style scoped>
@media screen and (max-width: 900px) {
    .scroll {
        background: linear-gradient(to right, #ffffff 90%, #efefef);
    }
}
.scroll {
    overflow-y: auto;
}
.flex {
    display: flex;
    font-weight: bold;
}
.col1 {
    padding-left: 47px;
}
.col2 {
    padding: 10px;
    min-width: 150px;
    width: calc(100% - 240px);
}
.col3 {
    padding: 10px;
    width: 80px !important;
    min-width: 80px !important;
}
</style>
